<template>
  <div class="search-content">
<!--    <keep-alive v-if="$route.meta.keepAlive">-->
      <router-view />
<!--    </keep-alive>-->
  </div>
</template>

<script>
  export default {
    name: 'ScoreLayout',
    data () {
      return {
        tabs: {
          items: [
            {
              key: '1',
              title: '组别管理'
            },
            {
              key: '2',
              title: '场次管理'
            },
            {
              key: '3',
              title: '对阵管理'
            },
            {
              key: '4',
              title: '场地管理'
            },
            // {
            //   key: '5',
            //   title: '教练管理'
            // },
            // {
            //   key: '6',
            //   title: '领队管理'
            // },
            // {
            //   key: '7',
            //   title: '执裁记录申请'
            // }
          ],
          active: () => {
            switch (this.$route.path) {
              case '/dscore/JianqiuVsGroup':
                return '1'
              case '/dscore/JianqiuStartList':
                return '2'
              case '/dscore/JianqiuVsMap':
                return '3'
              case '/dscore/JianqiuPlaceList':
                return '4'
              case '/sai/jiaolianList':
                return '5'
              case '/sai/lingduiList':
                return '6'
              case '/sai/scorecaipanList':
                return '7'
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '1':
                this.$router.push('/dscore/JianqiuVsGroup')
                break
              case '2':
                this.$router.push('/dscore/JianqiuStartList')
                break
              case '3':
                this.$router.push('/dscore/JianqiuVsMap')
                break
              case '4':
                this.$router.push('/dscore/JianqiuPlaceList')
                break
              case '5':
                this.$router.push('/sai/jiaolianList')
                break

              case '6':
                this.$router.push('/sai/lingduiList')
                break
              case '7':
                this.$router.push('/sai/scorecaipanList')
                break
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>
